import { Alert, Button, Grid, Snackbar } from '@mui/material';
import React, { useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import { maximusImport, mxemrimport } from '../../../services/api/apiManager';
import WebLogo from '../../../../assets/logos/websitelogo.svg';
function EMRimport() {
	// snackbar 1 code
	const [snackbarOpen, setSnackbarOpen] = useState(false);
	const handleOpenSnackbar = () => {
		setSnackbarOpen(true);
	};
	const [loading, setLoading] = useState(false);
	const handleCloseSnackbar = () => {
		setSnackbarOpen(false);
	};
	// snack bar 2 code
	const [snackbarOpenError, setSnackbarOpenError] = useState(false);
	const [errortext, seterrortext] = useState(false);
	const handleError = (text) => {
		seterrortext(text);
		setSnackbarOpenError(true);
	};
	const handleCloseError = () => {
		setSnackbarOpenError(false);
	};
	const OSW_id = localStorage.getItem('OSW_id');
	const data = {
		OSW_id: OSW_id,
		OSWPractice_id: localStorage.getItem('OID'),
		action: 'patientlist',
	};
	const handleClick = async () => {
		// Increment the click count
		debugger;
		setLoading(true);
		if (OSW_id == '1') {
			try {
				const res = await maximusImport(data);
				if (res?.status === 200) {
					handleOpenSnackbar(); // Display a success message
				} else {
					handleError(res?.response?.data?.err);
				}
			} catch (error) {
				console.log('An error occurred: ', error);
				handleError(); // Show an error message
			}
		} else if (OSW_id == '2') {
			try {
				const res = await mxemrimport(data);
				if (res?.status === 201 || res?.status === 200) {
					handleOpenSnackbar(); // Display a success message
				} else {
					handleError(res?.response?.data?.err);
				}
			} catch (error) {
				console.log('An error occurred: ', error);
				handleError(); // Show an error message
			}
		}
		setLoading(false);
	};
	return (
		<>
			<Grid
				item
				xs={12}
				lg={12}
				sm={12}
				md={12}
				xl={12}
				sx={{ display: 'flex', justifyContent: 'flex-end' }}
			>
				<Button
					onClick={() => handleClick()}
					sx={{
						background: '#0D406F',
						color: 'white',
						border: ' 1px solid #0D406F',
						'&:hover': {
							border: ' 1px solid #0D406F',
							color: '#0D406F',
						},
					}}
					startIcon={<AddIcon fontSize="small" />}
				>
					{OSW_id == '1' ? 'Import Data from Maximus	' : 'Import Data from EMR'}
				</Button>
				{/* SnacKbar 1*/}
				<Snackbar
					open={snackbarOpen}
					autoHideDuration={3000} // Adjust the duration as needed
					onClose={handleCloseSnackbar}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				>
					<Alert
						onClose={handleCloseSnackbar}
						severity="success"
						variant="filled"
					>
						Data Imported successfully.
					</Alert>
				</Snackbar>
				{/* SnacKbar 2*/}
				<Snackbar
					open={snackbarOpenError}
					autoHideDuration={3000} // Adjust the duration as needed
					onClose={handleCloseError}
					anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
				>
					<Alert onClose={handleCloseError} severity="error" variant="filled">
						{errortext}
					</Alert>
				</Snackbar>
			</Grid>
			<Grid>
				{loading && (
					<div className="loading-container">
						<div className="logo-container">
							<img className="logo" src={WebLogo} alt="Website Logo" />
						</div>
					</div>
				)}
			</Grid>
		</>
	);
}

export default EMRimport;
